

const Pipeline = [
    { code: 1, name: 'Оформил заказ', color: 'primary.main' },
    { code: 2, name: 'Проблемный', color: 'secondary.main' },
    { code: 3, name: 'Отправленный', color: 'info.main' },
    { code: 4, name: 'Доставленный', color: 'success.main' },
]

const Transport = [
    {'code': 'mydelivengo', 'name': 'My Delivengo'},
    {'code': 'colissimo', 'name': 'Colissimo'},
    {'code': 'ups', 'name': 'UPS'},
    {'code': 'poste_ru', 'name': 'Почта России'},
    {'code': 'mondial_relay', 'name': 'Mondial Relay'},
]



const Sources = {
    'ebay': {
        'code': 'ebay',
        'name': 'eBay',
        'division': 'FR',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': true
    },
    'amazon': {
        'code': 'amazon',
        'name': 'Amazon',
        'division': 'FR',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    },
    'site_en': {
        'code': 'site_en',
        'name': 'Site EN',
        'division': 'FR',
        'emailConfigOrder': true,
        'emailStatusOrder': false,
        'emailConfigShiping': true,
        'emailStatusShiping': false,
        'automaticShipment': true
    },
    'site_ru': {
        'code': 'site_ru',
        'name': 'Site RU',
        'division': 'RU',
        'emailConfigOrder': true,
        'emailStatusOrder': false,
        'emailConfigShiping': true,
        'emailStatusShiping': false,
        'automaticShipment': true
    },
    'wb': {
        'code': 'wb',
        'name': 'Wildberries',
        'division': 'RU',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    },
    'ozon': {
        'code': 'ozon',
        'name': 'Ozon',
        'division': 'RU',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    },
    'yandex': {
        'code': 'yandex',
        'name': 'Yandex Market',
        'division': 'RU',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    },
    'megamarket': {
        'code': 'megamarket',
        'name': 'Megamarket',
        'division': 'RU',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    },
    'other': {
        'code': 'other',
        'name': 'Other',
        'division': 'FR',
        'emailConfigOrder': false,
        'emailStatusOrder': false,
        'emailConfigShiping': false,
        'emailStatusShiping': false,
        'automaticShipment': false
    }
}




const creatURLGoogleMap = (lst) => {

    let valuer = Object.values(lst).slice(0, -1)
    let urlArrey = valuer.filter(i => {
        if (typeof i === 'string') {
            return i
        }
    })
    const url = 'https://www.google.com/maps/search/?api=1&query=' + `${encodeURIComponent(urlArrey)}`
    window.open(url)
}

const openURL = (url) => {

    window.open(url)
}


const iconColors = {
    gray: '#EAECEE',
    yellow: '#F4D03F',
    green: '#58D68D',
    grayDark: '#838181de',
    blue: '#1976d2'
}


function capitalizeFirstLetter(string) {

    const lst = string.split(' ')
    let newLst = []
    for (const i in lst){
        newLst.push(lst[i].charAt(0).toUpperCase() + lst[i].slice(1))
    }
    return newLst.join(' ')
}

const orderTableHeaders = ['Дата', 'Номер заказа', 'Платформа', 'Страна', 'Город', 'Кол-во', 'Стоимость', 'Клиент', 'E-mail']

const tableCell = (value) => String(value ?? '').replace(/[\t\r\n]/g, ' ')

const ordersToExcelTable = (orders) => {
    const lines = [orderTableHeaders]
    for (const order of orders) {
        const user = order.user || {}
        const address = order.address || {}
        const price = Number(order.totalOrderPrice || 0).toFixed(2)
        lines.push([
            order.date,
            order.orderID,
            order.source && order.source.name,
            address.country,
            address.city,
            order.totalQuantity,
            price,
            [user.firstName, user.lastName].filter(Boolean).join(' '),
            user.email,
        ])
    }
    return lines.map((row) => row.map(tableCell).join('\t')).join('\r\n')
}

export {capitalizeFirstLetter, Sources, iconColors, creatURLGoogleMap,  Pipeline, openURL, Transport, ordersToExcelTable };
